// import { useState } from 'react';
import { useEffect, useState } from 'react';
import style from './WallpaperMenu.module.css'

export default function WallpaperMenu() {

    
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const url = [
        './img/wallpapertest/templonoite.png',        
        './img/wallpapertest/parlamento.jpeg',
        // './img/wallpapertest/templo5.jpg',
    ]
    // const getRandomIndex = () => Math.floor(Math.random() * 3);
    // const [randomIndex] = useState(getRandomIndex());
    return (
        <>
            {isDesktop && <img className={style.imgWallpaper} src={url[0]} alt='' />}
        </>
    )
}
